var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33317 1.33334C5.33317 0.965149 5.63165 0.666672 5.99984 0.666672C6.36803 0.666672 6.6665 0.965149 6.6665 1.33334V6.10518L8.82834 3.94334L9.77115 4.88615L5.99991 8.65739L2.22868 4.88615L3.17149 3.94334L5.33317 6.10503V1.33334Z",
    fill: "#027EFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 7.33334H1.99984V10H9.99984V7.33334H11.3332V10C11.3332 10.7364 10.7362 11.3333 9.99984 11.3333H1.99984C1.26346 11.3333 0.666504 10.7364 0.666504 10V7.33334Z",
    fill: "#027EFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.37f65f88cdc2225111e86e7616a6bdf2.svg";
export { ForwardRef as ReactComponent };